import React from "react";
import cx from "classnames";
// eslint-disable-next-line no-restricted-imports
import { toTel } from "../../utils/toTel";
import stylesV2 from "./FooterV2.module.scss";
import stylesV3 from "./FooterV3.module.scss";
import { useSchedulingABVariant } from "../../utils/useSchedulingABVariant";
import { MYEYEDR_WEBSITE_URL } from "utils/constants";
import { InfoTooltip } from "components/InfoTooltip";

export interface FooterProps {
  formattedPhone: string;
  showSMSContent?: boolean;
  useSuccessPageCopy?: boolean;
  useV3StartPageCopy?: boolean;
}
declare let orderContactUrl: string;
export const Footer: React.FC<FooterProps> = ({
  formattedPhone,
  showSMSContent,
  useSuccessPageCopy = false,
  useV3StartPageCopy = false,
}) => {
  const { isV3 } = useSchedulingABVariant();
  const styles = isV3 ? stylesV3 : stylesV2;
  const useEyecareNeedsCopy = useSuccessPageCopy || (isV3 && useV3StartPageCopy);
  return (
    <>
      <div className={styles.footer}>
        <section className={cx(styles.footerSection, styles.footerLeft)}>
          <div className={styles.footerHeadingWithTooltip}>
            <h3 className={styles.footerHeading}>
              Other eyecare/vision needs?
            </h3>
            <InfoTooltip>
              <p>
                Please call our office to schedule appointments for follow-ups
                or urgent concerns.
              </p>
              <p>
                Urgent concerns may include any kind of eye infection or injury
                that impairs vision. Some examples are seeing floaters or
                flashing lights.
              </p>
            </InfoTooltip>
          </div>
          <p className={styles.footerParagraph}>
            {useEyecareNeedsCopy
              ? "If you are experiencing any eyecare/vision needs outside of your exam, please call the office at "
              : "If you are experiencing an ocular emergency or vision loss, please pick up the phone and call this office immediately."}
            <a href={toTel(formattedPhone)} className={styles.footerPhoneLink}>
              {formattedPhone}
            </a>
            {useEyecareNeedsCopy ? " to schedule an appointment." : null}
          </p>
        </section>
        <hr className={styles.footerDivider} />
        <section className={cx(styles.footerSection, styles.footerRight)}>
          <h3 className={styles.footerHeading}>
            Need new glasses or contacts?
          </h3>
          <p className={styles.footerLinkContainer}>
            <a
              href={`${MYEYEDR_WEBSITE_URL}/eye-wear/shop-glasses`}
              target="_blank"
              rel="noreferrer"
              className={styles.footerLink}
            >
              Browse Glasses
            </a>
          </p>
          <p className={styles.footerLinkContainer}>
            <a
              href={orderContactUrl}
              target="_blank"
              rel="noreferrer"
              className={styles.footerLink}
            >
              Order Contacts
            </a>
          </p>
        </section>
      </div>
      {showSMSContent && (
        <section className={styles.smsFooter}>
          <p>
            * When scheduling an appointment on MyEyeDr.’s website, you are subscribed to receive email messages regarding your appointment and treatment as well as discounts and promotions. You can opt out of email messages at any time through the <i>Manage Email Preferences</i> link in any email or by contacting us at  {" "}
            <a href="mailto:PatientRelations@myeyedr.com">
              PatientRelations@myeyedr.com
            </a>.
          </p>
          <p className={styles.smsHelp}>
            * Message frequency varies. Message and data rates may apply. At any
            time you can text HELP for help or text STOP to stop notifications.{" "}
            <a
              href="https://www.myeyedr.com/sms-terms-service"
              target="_blank"
              rel="noreferrer"
            >
              SMS Terms of Service
            </a>{" "}
            |{" "}
            <a
              href="https://www.myeyedr.com/privacy-policy-practices"
              target="_blank"
              rel="noreferrer"
            >
              MyEyeDr. Privacy Policy
            </a>
          </p>

          <div className={styles.agreeText}>
            * I agree that you can contact me by text at the mobile number
            provided. By agreeing I consent to receiving texts about promotional
            offers related to eyewear and eyecare offers by any type of dialing
            equipment, automated technology, or other messaging system to send
            the communications. I understand message frequency varies and that
            data and message rates may apply.{" "}
            <u>
              I understand that I am not required to agree to such messaging,
              and it is not a condition for the purchase of any goods or
              services.
            </u>
            <p>* For more information about offers, discounts, and promotions - including Terms & Conditions - visit our{" "} 
              <a href="https://www.myeyedr.com/offers" target="blank">Offers page.</a>
            </p>
          </div>
        </section>
      )}
    </>
  );
};
